import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
})
  
const Loading = ({classes, pastDelay}) => {
    if(pastDelay){
        return(
            <CircularProgress className={classes.progress} />
        )
    }
    else{
        return null
    }
}

Loading.propTypes = {
    classes: PropTypes.object.isRequired,
    pastDelay: PropTypes.bool
}

export default withStyles(styles)(Loading)



// WEBPACK FOOTER //
// ./src/Loading.js